import { useMemo } from 'react';
import { IdNameDto } from '../Types/common';

// Uniwersalny typ dla mapowania kluczy z pola na klucz filterData
type FieldToFilterKey = Record<string, string>;

// Minimalny typ pola formularza, możesz rozszerzyć
type Field = {
  name: string;
  type: string;
  [key: string]: any;
};

// Hook z możliwością przekazania zewnętrznego mappingu kluczy!
export function useFieldsWithFilterOptions<T extends Field>(
  fields: T[],
  filterData?: Record<string, any>,
  fieldToFilterKey?: FieldToFilterKey
): T[] {
  return useMemo(() => {
    return fields.map((field) => {
      // Pobieramy klucz do filterData z mapowania (lub domyślnie nazwa pola)

      const filterKey = fieldToFilterKey?.[field.name] ?? field.name;
      // Sprawdzamy czy typ pola to select/autocomplete i czy są dostępne opcje
      if (
        (field.type === 'select' || field.type === 'autocomplete') &&
        filterData &&
        filterData[filterKey]
      ) {
        return {
          ...field,
          options: filterData[filterKey].map((option: IdNameDto) => ({
            name: option.name, // **tu label, bo MUI Select tak oczekuje**
            id: String(option.id),
          })),
        };
      }
      return { ...field, name: field.name as keyof T };
    });
  }, [fields, filterData, fieldToFilterKey]);
}
